import React from 'react';
import { DatabaseIcon, PencilLineIcon, ShuffleIcon } from 'lucide-react';
import { useContentNotes } from '../contexts/ContentNotesContext';
import type { NoteKind } from '../types/landing';
interface ContentNoteProps {
  kind: NoteKind;
  detail: string;
  className?: string;
}
export const noteStyles: Record<NoteKind, {
  label: string;
  cls: string;
  Icon: typeof DatabaseIcon;
}> = {
  wp: {
    label: 'WordPress editable',
    cls: 'bg-note-wp text-note-wpInk border-note-wpLine',
    Icon: PencilLineIcon
  },
  dynamic: {
    label: 'Backend dynamic',
    cls: 'bg-note-dyn text-note-dynInk border-note-dynLine',
    Icon: DatabaseIcon
  },
  hybrid: {
    label: 'Hybrid',
    cls: 'bg-note-hy text-note-hyInk border-note-hyLine',
    Icon: ShuffleIcon
  }
};
export function ContentNote({
  kind,
  detail,
  className = 'right-3 top-3'
}: ContentNoteProps) {
  const on = useContentNotes();
  if (!on) return null;
  const {
    label,
    cls,
    Icon
  } = noteStyles[kind];
  return <aside aria-label={`Content note: ${label}`} className={`absolute z-30 max-w-[260px] rounded-md border px-2.5 py-1.5 text-[11px] leading-snug shadow-sm ${cls} ${className}`} data-id="element-11" data-mp="1goskqoo66jbw">
      <span className="flex items-center gap-1 font-semibold uppercase tracking-wide" data-id="element-12" data-mp="2kyu9txwcbt0o">
        <Icon className="h-3 w-3" aria-hidden="true" data-id="element-13" data-mp="2gzlewppkdp3j" />
        {label}
      </span>
      <span className="mt-0.5 block" data-id="element-14" data-mp="2c0qxns78w8lj">{detail}</span>
    </aside>;
}